import blank from './blank';

export default {
  ...blank, id: 'full-width', label: 'Full Width — With Header/Footer', includeChrome: true,
};
